import React from "react"
import { useHistory } from "react-router-dom"
import { useResetRecoilState } from "recoil"
import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"
import { Auth } from "aws-amplify"

export default function Logout({ logo, fullWidth, title }) {
  const history = useHistory()
  const resetAssociation = useResetRecoilState(currentAssociation)
  const resetUser = useResetRecoilState(currentUser)

  async function handleLogout() {
    await Auth.signOut()
    resetAssociation()
    resetUser()
    history.push("/signin")
  }

  React.useEffect(() => {
    handleLogout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return undefined
}
